import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '@hero/constants';

import * as organizationServices from '../../services';

export const useGetOrganizationUserCount = options => {
  return useQuery(
    [QUERY_KEYS.useGetOrganizationUserCount],
    () => organizationServices.getOrganizationUsersCount(),
    options
  );
};
